var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 1.054c-.219.377-.38.803-.477 1.187-.461 1.798-1.005 3.484-1.959 5.104-1.96 3.334-6.006 6.174-8.09 8.15-2.083 1.975-1.96 7.78-.612 10.001 1.348 2.223 7.967 5.31 12.747 5.928 4.781.617 7.778-.589 9.862-2.935 2.083-2.346.322-3.896.322-3.896s1.606-.899 1.735-2.846c.102-1.547-1.012-1.973-1.024-2.578-.007-.41.298-.951.592-1.378.574-.827.855-1.85.654-2.838-.101-.5-.32-1.01-.74-1.434-1.164-1.172-11.4-1.111-11.4-1.111S16.184 8.21 15.94 5c-.1-1.312-.215-3.73-1.391-4.615-1.087-.818-1.913-.208-2.425.669",
    transform: "translate(-96 -1271) translate(39 1271) translate(57)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionLike);
export default __webpack_public_path__ + "static/media/reactionLike.400eb521.svg";
export { ForwardRef as ReactComponent };